module.exports = __webpack_public_path__ + "images/b1af79d24bb6ba661ddb9ad30e9db126.svg";